import React from 'react';

import type { SgmDescription } from '@swf/generated/types/api/sports';

import styles from './SgmBetDetails.scss';

interface Props {
  sgmDescription: SgmDescription;
}

const SgmBetDetails: React.FC<Props> = ({ sgmDescription }) => {
  const { marketName, runnerName } = sgmDescription;

  return (
    <div className={styles.container}>
      <span className={styles.title}>{runnerName}</span>
      <span className={styles.marketName}>{marketName}</span>
    </div>
  );
};

export default SgmBetDetails;
